__turbopack_context__.v({
  "arrow": "SchoolsDropdown-module-scss-module__JXKucW__arrow",
  "arrowVisible": "SchoolsDropdown-module-scss-module__JXKucW__arrowVisible",
  "blocksBackgroundColor": "SchoolsDropdown-module-scss-module__JXKucW__blocksBackgroundColor",
  "blocksFontColor": "SchoolsDropdown-module-scss-module__JXKucW__blocksFontColor",
  "breakContainer": "SchoolsDropdown-module-scss-module__JXKucW__breakContainer",
  "buttonTextContainer": "SchoolsDropdown-module-scss-module__JXKucW__buttonTextContainer",
  "categoryList": "SchoolsDropdown-module-scss-module__JXKucW__categoryList",
  "container": "SchoolsDropdown-module-scss-module__JXKucW__container",
  "containerHidden": "SchoolsDropdown-module-scss-module__JXKucW__containerHidden",
  "desktopDropdown": "SchoolsDropdown-module-scss-module__JXKucW__desktopDropdown",
  "dropdown": "SchoolsDropdown-module-scss-module__JXKucW__dropdown",
  "faIcon": "SchoolsDropdown-module-scss-module__JXKucW__faIcon",
  "mobileDropdown": "SchoolsDropdown-module-scss-module__JXKucW__mobileDropdown",
  "secondaryNavBackgroundColor": "SchoolsDropdown-module-scss-module__JXKucW__secondaryNavBackgroundColor",
  "stickyButton": "SchoolsDropdown-module-scss-module__JXKucW__stickyButton",
  "themeBackgroundColor": "SchoolsDropdown-module-scss-module__JXKucW__themeBackgroundColor",
  "themeFontColor": "SchoolsDropdown-module-scss-module__JXKucW__themeFontColor",
  "themeFontFamily": "SchoolsDropdown-module-scss-module__JXKucW__themeFontFamily",
  "transitionEnter": "SchoolsDropdown-module-scss-module__JXKucW__transitionEnter",
  "transitionEnterActive": "SchoolsDropdown-module-scss-module__JXKucW__transitionEnterActive",
  "transitionEnterDone": "SchoolsDropdown-module-scss-module__JXKucW__transitionEnterDone",
  "transitionExit": "SchoolsDropdown-module-scss-module__JXKucW__transitionExit",
  "transitionExitActive": "SchoolsDropdown-module-scss-module__JXKucW__transitionExitActive",
  "transitionExitDone": "SchoolsDropdown-module-scss-module__JXKucW__transitionExitDone",
});
